
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("fsLhR", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "AGG_NO_PROJECT_DATA", () => $270c5cf11e1379f1$export$df64fe7442e4c87b);
$parcel$export(module.exports, "default", () => $270c5cf11e1379f1$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import-whitelist

var $j40FL = parcelRequire("j40FL");

var $2vSU6 = parcelRequire("2vSU6");

var $jJZqs = parcelRequire("jJZqs");

var $eusud = parcelRequire("eusud");

var $dXq4S = parcelRequire("dXq4S");

var $1nb22 = parcelRequire("1nb22");

var $bTWdn = parcelRequire("bTWdn");

const $270c5cf11e1379f1$export$df64fe7442e4c87b = 512;
const $270c5cf11e1379f1$var$fetchProjectByKey = (projectKey, cloudId)=>(0, $eusud.performPostRequest)('/gateway/api/graphql', {
        method: 'POST',
        headers: {
            'content-type': 'application/json',
            'X-ExperimentalApi': 'JiraProject, projectStyle'
        },
        body: JSON.stringify({
            query: (0, $244a3729a91e0120$export$acf424575996ea1b),
            variables: {
                projectKey: projectKey,
                cloudId: cloudId
            }
        })
    });
const $270c5cf11e1379f1$var$fetchProjectById = (projectId, cloudId)=>{
    const projectAri = (0, $dXq4S.createAri)({
        resourceOwner: 'jira',
        resourceType: 'project',
        resourceId: projectId,
        cloudId: cloudId
    });
    return (0, $eusud.performPostRequest)('/gateway/api/graphql', {
        method: 'POST',
        headers: {
            'content-type': 'application/json',
            'X-ExperimentalApi': 'projectStyle'
        },
        body: JSON.stringify({
            query: (0, $244a3729a91e0120$export$53dcad789349e3a8),
            variables: {
                projectAri: projectAri
            }
        })
    });
};
const $270c5cf11e1379f1$var$mapProjectDataToContext = (project)=>{
    const { projectId: projectId, key: key, uuid: uuid, name: name, avatar: avatar, projectType: projectType, projectStyle: projectStyle, status: status, created: created } = project;
    return {
        projectKey: key,
        projectId: +projectId,
        projectUuid: uuid,
        projectName: name,
        avatarUrl: avatar?.medium ?? '',
        simplified: projectStyle === (0, $2vSU6.TEAM_MANAGED_PROJECT),
        projectType: (0, $2vSU6.convertToProjectType)(projectType),
        isProjectArchived: status === (0, $2vSU6.JIRA_PROJECT_STATUS_ARCHIVED),
        created: created
    };
};
const $270c5cf11e1379f1$var$getProjectContextData = async (projectKey, projectId, cloudId)=>{
    const fetchStartTime = performance.now();
    const { data: data, errors: errors } = projectKey ? await $270c5cf11e1379f1$var$fetchProjectByKey(projectKey, cloudId) : await $270c5cf11e1379f1$var$fetchProjectById(projectId, cloudId);
    (0, $j40FL.addSpanToAll)('fetch', projectKey ? 'fetchProjectByKey' : 'fetchProjectById', [
        {
            name: 'network'
        }
    ], fetchStartTime, performance.now());
    if (errors != null && errors.length > 0) {
        const statusCode = errors[0].extensions?.statusCode;
        throw new (0, $jJZqs.default)(statusCode, `Fetch project context via AGG failed. Errors: ${errors.map((err)=>err.message).join(', ')}`);
    }
    const projectData = data?.jira?.jiraProject || data?.jira?.jiraProjectByKey;
    if (!projectData) throw new (0, $jJZqs.default)($270c5cf11e1379f1$export$df64fe7442e4c87b, 'Fetch project context via AGG succeeded but no data received');
    return $270c5cf11e1379f1$var$mapProjectDataToContext(projectData);
};
const $270c5cf11e1379f1$var$checkNonEmptyString = (input)=>input !== null && input !== undefined && input !== '';
var /**
 * Determines if the current user is an admin of the specified project by extracting project identifiers from a route, verifying these identifiers, and concurrently fetching project context and user permissions. It handles errors gracefully by throwing exceptions if data retrieval fails.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$270c5cf11e1379f1$export$2e2bcd8739ae039 = async (matchedRoute, { tenantContext: { cloudId: cloudId } })=>{
    let { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(matchedRoute.match, matchedRoute.query);
    const projectArg = projectKey || projectId;
    if (projectArg == null) return null;
    if ($270c5cf11e1379f1$var$checkNonEmptyString(projectKey) && !Number.isNaN(Number(projectKey))) {
        // In the cases when the value of projectKey is numerical and apprears to be the value of projectId,
        // We take the projectKey as projectId if there isn't existing value for projectId
        projectId = $270c5cf11e1379f1$var$checkNonEmptyString(projectId) ? projectId : projectKey;
        projectKey = '';
    }
    const [projectResult, permissionResult] = await Promise.allSettled([
        $270c5cf11e1379f1$var$getProjectContextData(projectKey, projectId, cloudId),
        (0, $bTWdn.isCurrentUserProjectAdmin)(projectArg)
    ]);
    if (permissionResult.status === 'rejected') throw permissionResult.reason;
    if (projectResult.status === 'rejected') throw projectResult.reason;
    return {
        ...projectResult.value,
        isProjectAdmin: permissionResult.value
    };
};

});
parcelRegister("dXq4S", function(module, exports) {

$parcel$export(module.exports, "isAri", () => $5c4418bd595ae8cf$export$8e68286aef4c3a8b);
$parcel$export(module.exports, "createAri", () => $5c4418bd595ae8cf$export$594d18a0ad2e0e57);
$parcel$export(module.exports, "toAri", () => $5c4418bd595ae8cf$export$24b47820a324e614);
$parcel$export(module.exports, "toAriOrDefault", () => $5c4418bd595ae8cf$export$e2789192113e8b07);
$parcel$export(module.exports, "parseAri", () => $5c4418bd595ae8cf$export$f8e7d14b19dc8ba5);
$parcel$export(module.exports, "getAriConfig", () => $5c4418bd595ae8cf$export$3d8d7031a11613fd);
/**
 * Module to work with Atlassian Resource Identifier (ARI)
 * More info in go/aris
 */ const $5c4418bd595ae8cf$var$ARI_REG_EXP = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/(?<resourceId>[\w.~_-]+)$/;
const $5c4418bd595ae8cf$var$ARI_REG_EXP_ACTIVATION = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/activation\/(?<activationId>[\w-]*)\/(?<resourceId>[\w.~_-]+)$/;
const $5c4418bd595ae8cf$var$ARI_REG_EXP_WORKSPACE = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>.{0}):(?<resourceType>[a-z.-]+)(\/(?<workspaceId>[\w.~_-]+)?)\/(?<resourceId>[\w.~_-]+)$/;
const $5c4418bd595ae8cf$var$ARI_REG_EXP_PROVIDER_CONTAINER = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/activation\/(?<activationId>[\w-]*)\/(?<providerAppId>[\w.~_-]+)\/(?<resourceId>[\w.~_/-]+)$/;
const $5c4418bd595ae8cf$export$8e68286aef4c3a8b = (ari)=>$5c4418bd595ae8cf$var$ARI_REG_EXP.test(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_WORKSPACE.test(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_ACTIVATION.test(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_PROVIDER_CONTAINER.test(ari);
const $5c4418bd595ae8cf$export$594d18a0ad2e0e57 = ({ resourceOwner: resourceOwner, cloudId: cloudId, resourceType: resourceType, workspaceId: workspaceId, resourceId: resourceId, activationId: activationId })=>{
    if (workspaceId != null) return `ari:cloud:${resourceOwner}::${resourceType}/${workspaceId}/${resourceId}`;
    if (activationId != null) return `ari:cloud:${resourceOwner}:${cloudId || ''}:${resourceType}/activation/${activationId}/${resourceId}`;
    return `ari:cloud:${resourceOwner}:${cloudId || ''}:${resourceType}/${resourceId}`;
};
const $5c4418bd595ae8cf$export$24b47820a324e614 = (ari)=>{
    if ($5c4418bd595ae8cf$export$8e68286aef4c3a8b(ari)) return ari;
    return undefined;
};
const $5c4418bd595ae8cf$export$e2789192113e8b07 = (ari, defaultValue = '')=>$5c4418bd595ae8cf$export$24b47820a324e614(ari) ?? defaultValue;
const $5c4418bd595ae8cf$export$f8e7d14b19dc8ba5 = (ari)=>{
    if ($5c4418bd595ae8cf$export$8e68286aef4c3a8b(ari)) {
        const parts = $5c4418bd595ae8cf$var$ARI_REG_EXP.exec(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_WORKSPACE.exec(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_ACTIVATION.exec(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_PROVIDER_CONTAINER.exec(ari);
        if (parts?.groups) {
            // reconstructing an object just to avoid flow error (otherwise says inexact object type of parts.groups is incompatible with exact AriConfig type)
            const { resourceOwner: resourceOwner, cloudId: cloudId, resourceType: resourceType, workspaceId: workspaceId, resourceId: resourceId, activationId: activationId } = parts.groups;
            return {
                resourceOwner: resourceOwner,
                cloudId: cloudId,
                resourceType: resourceType,
                workspaceId: workspaceId,
                resourceId: resourceId,
                activationId: activationId
            };
        }
    }
    return undefined;
};
const $5c4418bd595ae8cf$export$3d8d7031a11613fd = (ari)=>{
    const config = $5c4418bd595ae8cf$export$f8e7d14b19dc8ba5(ari);
    if (config === undefined) throw Error('Invalid ARI - this should only be possible if there is a bug in `toAri`');
    return config;
};

});

parcelRegister("bTWdn", function(module, exports) {

$parcel$export(module.exports, "isCurrentUserProjectAdmin", () => $50bf0bcdf8ba40ed$export$146b7031c6ad53af);

var $icGZu = parcelRequire("icGZu");

var $j40FL = parcelRequire("j40FL");

var $eusud = parcelRequire("eusud");
const $50bf0bcdf8ba40ed$var$ADMINISTER_PROJECTS_PERMISSION = 'ADMINISTER_PROJECTS';
const $50bf0bcdf8ba40ed$var$getMyPermissionsGraphQLQuery = (projectKeyOrId)=>`query myPermissionsDataQuery {
        mypermissions(${Number.isNaN(+projectKeyOrId) ? `projectKey: "${projectKeyOrId}"` : `projectId: "${projectKeyOrId}"`}
        permissions: "${$50bf0bcdf8ba40ed$var$ADMINISTER_PROJECTS_PERMISSION}") {
            key
            havePermission
        }
    }`;
const $50bf0bcdf8ba40ed$var$fetchMyPermissions = (projectKeyOrId)=>(0, $eusud.performPostRequest)('/rest/graphql/1/?', {
        method: 'POST',
        body: JSON.stringify({
            query: $50bf0bcdf8ba40ed$var$getMyPermissionsGraphQLQuery(projectKeyOrId)
        })
    });
const $50bf0bcdf8ba40ed$export$146b7031c6ad53af = async (projectArg)=>{
    const fetchStartTime = performance.now();
    const { data: data, errors: errors } = await $50bf0bcdf8ba40ed$var$fetchMyPermissions(projectArg);
    (0, $j40FL.addSpanToAll)('fetch', 'fetchMyPermissions', [
        {
            name: 'network'
        }
    ], fetchStartTime, performance.now());
    const hasError = errors && errors.length > 0;
    if (hasError || !data?.mypermissions) {
        const error = new Error(`Project admin permission check failed: ${hasError ? errors[0].message : 'no data'}`);
        // @ts-expect-error - TS2339 - Property 'statusCode' does not exist on type 'Error'.
        error.statusCode = hasError ? errors[0].statusCode : 500;
        // @ts-expect-error - TS2339 - Property 'skipSentry' does not exist on type 'Error'.
        error.skipSentry = hasError ? errors[0].statusCode === 404 : false;
        // We want to provide a degraded user experience if we get 4xx error and can't determine if the user is a project admin.
        if (hasError && errors[0].statusCode >= 400 && errors[0].statusCode <= 499) return false;
        throw error;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($icGZu)))(data.mypermissions, {
        key: $50bf0bcdf8ba40ed$var$ADMINISTER_PROJECTS_PERMISSION,
        havePermission: true
    });
};

});
parcelRegister("icGZu", function(module, exports) {

var $2k3l6 = parcelRequire("2k3l6");

var $bxDef = parcelRequire("bxDef");

var $6kYP8 = parcelRequire("6kYP8");

var $8LQ84 = parcelRequire("8LQ84");

var $4rDUz = parcelRequire("4rDUz");
/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */ function $d40ab2104a331ebd$var$some(collection, predicate, guard) {
    var func = $8LQ84(collection) ? $2k3l6 : $6kYP8;
    if (guard && $4rDUz(collection, predicate, guard)) predicate = undefined;
    return func(collection, $bxDef(predicate, 3));
}
module.exports = $d40ab2104a331ebd$var$some;

});
parcelRegister("6kYP8", function(module, exports) {

var $e7pfQ = parcelRequire("e7pfQ");
/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $49d3cab0435826ab$var$baseSome(collection, predicate) {
    var result;
    $e7pfQ(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
    });
    return !!result;
}
module.exports = $49d3cab0435826ab$var$baseSome;

});



const $244a3729a91e0120$var$ProjectFragment = `
fragment ProjectFragment on JiraProject {
  id
  projectId
  key
  uuid
  name
  avatar {
    medium
  }
  projectType
  projectStyle
  status
  created
}
`;
const $244a3729a91e0120$export$acf424575996ea1b = `
query jiraProjectByKey($projectKey: String!, $cloudId: ID!) {
  jira {
    jiraProjectByKey(key: $projectKey, cloudId: $cloudId) {
      ...ProjectFragment
    }
  }
}
${$244a3729a91e0120$var$ProjectFragment}
`;
const $244a3729a91e0120$export$53dcad789349e3a8 = `
query jiraProject($projectAri: ID!) {
  jira {
    jiraProject(id: $projectAri) {
      ...ProjectFragment
    }
  }
}
${$244a3729a91e0120$var$ProjectFragment}
`;



//# sourceMappingURL=async-resource-project-context.502067dd.js.map
